import React from 'react';
import { t } from '@lingui/core/macro';
import { CircularProgress } from '@mui/material';
import SyncIcon from '@mui/icons-material/Sync';

interface GoogleSheetsLoaderProps {
  hasGoogleSheetsData: boolean;
  isLoading: boolean;
  error?: string | null;
  onLoadGoogleSheets: () => void | Promise<void>;
  loadButtonRef?: React.RefObject<HTMLButtonElement | null>;
}

const GoogleSheetsLoader: React.FC<GoogleSheetsLoaderProps> = ({
  hasGoogleSheetsData,
  isLoading,
  error,
  onLoadGoogleSheets,
  loadButtonRef,
}) => {
  const handleClick = (): void => {
    const result = onLoadGoogleSheets();
    if (result instanceof Promise) {
      result.catch((loadError: unknown) => {
        console.error('Error loading from Google Sheets:', loadError);
      });
    }
  };

  return (
    <div className="google-sheets-loader">
      <button ref={loadButtonRef} className="load-button" onClick={handleClick} disabled={isLoading}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', width: '100%' }}>
          {isLoading ? (
            <>
              <CircularProgress size={16} style={{ marginRight: '8px' }} />
              {t`Loading from Google Sheets...`}
            </>
          ) : (
            <>
              <SyncIcon style={{ marginRight: '8px', fontSize: '18px' }} />
              {hasGoogleSheetsData ? t`Load from Google Sheets` : t`No Google Sheets data available`}
            </>
          )}
        </div>
      </button>
      {error && <div style={{ color: 'red', marginTop: '8px', fontSize: '14px' }}>{error}</div>}
    </div>
  );
};

export default GoogleSheetsLoader;
